import { WeatherStationLocationType } from 'types/markerTypes/marker.weatherStation.js';

export type SoilData = { temperature?: number; moisture?: number };

export const getSoilData = (
  value: WeatherStationLocationType['value'],
): { temperature?: number; moisture?: number } | undefined => {
  if ('soil' in value) {
    const soilMoisture = value.soil;
    return soilMoisture;
  }
  return undefined;
};
